import React, { useEffect } from "react";
import Avatar from "@mui/material/Avatar";
import Button from "@mui/material/Button";
import CssBaseline from "@mui/material/CssBaseline";
import TextField from "@mui/material/TextField";
import Link from "@mui/material/Link";
import Paper from "@mui/material/Paper";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import CircularProgress from "@mui/material/CircularProgress";
import Typography from "@mui/material/Typography";
import authBgImg from "../../images/bg-img.png";
import useApp from "../../store/contexts/AppContext";
import Copyright from "../../components/Copyright/Copyright";
import { ROUTES } from "../../routes/User/paths";
import { Link as RouterLink, useHistory } from "react-router-dom";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import { REACT_APP_AFTER_LOGIN_REDIRECT_URL } from "../../config";

export default function ForgotPassword() {
  const {
    appState: { appName, accessToken, dataLoading },
    forgotPasswordApiCall,
  } = useApp();

  const history = useHistory();

  const hour = new Date().getHours();
  const isDay = hour >= 6 && hour < 18;
  const authTheme = createTheme({
    palette: {
      mode: isDay ? "light" : "dark",
      primary: { main: "#d44401" },
      background: {
        default: isDay ? "#f8f9fa" : "#0a0a0a",
        paper: isDay ? "#ffffff" : "#0a0a0a",
      },
    },
  });

  const handleSubmit = (event) => {
    event.preventDefault();
    const form = new FormData(event.currentTarget);
    const dataToPass = {
      username: form.get("email"),
    };
    forgotPasswordApiCall(dataToPass);
  };

  useEffect(() => {
    if (accessToken) {
      history.push(REACT_APP_AFTER_LOGIN_REDIRECT_URL);
    }
  }, [accessToken, history]);

  // Prevent rendering if already authenticated
  if (accessToken) {
    return null;
  }

  return (
    <ThemeProvider theme={authTheme}>
    <Grid container component="main" sx={{ height: "100vh" }}>
      <CssBaseline />
      <Grid
        item
        xs={false}
        sm={4}
        md={7}
        sx={{
          backgroundImage: `url(${authBgImg})`,
          backgroundRepeat: "no-repeat",
          backgroundColor: isDay ? "#f8f9fa" : "#0a0a0a",
          backgroundSize: "cover",
          // backgroundPosition: "center",
        }}
      />
      <Grid item xs={12} sm={8} md={5} component={Paper} elevation={6} square>
        <Box
          sx={{
            my: 8,
            mx: 4,
          }}
        >
          <Box align="center">
            <Avatar sx={{ m: 1, bgcolor: "primary.main" }}>
              <LockOutlinedIcon />
            </Avatar>
          </Box>
          <Typography component="h1" variant="h5" align="center">
            Forgot password on {appName}
          </Typography>
          <Box
            component="form"
            noValidate
            onSubmit={handleSubmit}
            sx={{ mt: 1 }}
          >
            <TextField
              margin="dense"
              required
              fullWidth
              id="email"
              label="Email Address"
              name="email"
              autoComplete="email"
              autoFocus
            />

            <Button
              type="submit"
              fullWidth
              variant="contained"
              sx={{ mt: 3, mb: 2 }}
            >
              Submit{" "}
              {dataLoading && (
                <CircularProgress sx={{ color: "white", ml: 2 }} size={24} />
              )}
            </Button>
            <Grid container>
              <Grid item>
                <Link component={RouterLink} to={ROUTES.root} variant="body2">
                  {"Remembered password? Login"}
                </Link>
              </Grid>
            </Grid>
            <Copyright sx={{ mt: 5 }} />
          </Box>
        </Box>
      </Grid>
    </Grid>
    </ThemeProvider>
  );
}
